// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_QueryDuration.scss
// module id = 640
// module chunks = 67 88